// extracted by mini-css-extract-plugin
export default {"animated-path":"CustomNewConnectionLine_animated-path__fiY4i","dashdraw":"CustomNewConnectionLine_dashdraw__LrV2d"};